module.exports = __webpack_public_path__ + "img/133.2e896e88.jpg";